webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+prg");
module.exports = __webpack_require__("lVK7");


/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__("Ml+6");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.es.js
var styled_components_es = __webpack_require__("VEsJ");

// CONCATENATED MODULE: ./src/shader/background.js
/* harmony default export */ var background = ({
  vertex: "\n    varying vec2 vUv;\n    void main()\t{\n      vUv = uv;\n      gl_Position = vec4( position, 1.0 );\n    }\n  ",
  fragment: "\n    varying vec2 vUv;\n    uniform float time;\n    void main()\t{\n      vec2 p = - 1.0 + 2.0 * vUv;\n      float a = time * 40.0;\n      float d, e, f, g = 1.0 / 40.0 ,h ,i ,r ,q;\n      e = 400.0 * ( p.x * 0.5 + 0.5 );\n      f = 400.0 * ( p.y * 0.5 + 0.5 );\n      i = 200.0 + sin( e * g + a / 150.0 ) * 20.0;\n      d = 200.0 + cos( f * g / 2.0 ) * 18.0 + cos( e * g ) * 7.0;\n      r = sqrt( pow( abs( i - e ), 2.0 ) + pow( abs( d - f ), 2.0 ) );\n      q = f / r;\n      e = ( r * cos( q ) ) - a / 2.0;\n      f = ( r * sin( q ) ) - a / 2.0;\n      d = sin( e * g ) * 176.0 + sin( e * g ) * 164.0 + r;\n      h = ( ( f + d ) + a / 2.0 ) * g;\n      i = cos( h + r * p.x / 1.3 ) * ( e + e + a ) + cos( q * g * 6.0 ) * ( r + h / 3.0 );\n      h = sin( f * g ) * 144.0 - sin( e * g ) * 212.0 * p.x;\n      h = ( h + ( f - e ) * q + sin( r - ( a + h ) / 7.0 ) * 10.0 + i / 4.0 ) * g;\n      i += cos( h * 2.3 * sin( a / 350.0 - q ) ) * 184.0 * sin( q - ( r * 4.3 + a / 12.0 ) * g ) + tan( r * g + h ) * 184.0 * cos( r * g + h );\n      i = mod( i / 5.6, 256.0 ) / 64.0;\n      if ( i < 0.0 ) i += 4.0;\n      if ( i >= 2.0 ) i = 4.0 - i;\n      d = r / 350.0;\n      d += sin( d * d * 8.0 ) * 0.52;\n      f = ( sin( a * g ) + 1.0 ) / 2.0;\n      gl_FragColor = vec4( vec3( f * i / 1.6, i / 2.0 + d / 13.0, i ) * d * p.x + vec3( i / 1.3 + d / 8.0, i / 2.0 + d / 18.0, i ) * d * ( 1.0 - p.x ), 1.0 );\n    }\n  "
});
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("GiK3");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./src/components/App.js
var _templateObject = _taggedTemplateLiteralLoose(['\n  html, body {\n    background: #222;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n  }\n'], ['\n  html, body {\n    background: #222;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: block;\n'], ['\n  display: block;\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }








Object(styled_components_es["b" /* injectGlobal */])(_templateObject);

var Canvas = styled_components_es["a" /* default */].canvas(_templateObject2);

var App__default = function (_React$PureComponent) {
  _inherits(_default, _React$PureComponent);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  _default.prototype.componentDidMount = function componentDidMount() {
    this.scene = new three_module["d" /* Scene */]();
    this.camera = new three_module["b" /* OrthographicCamera */](-1, 1, 1, -1, 0, 1);

    this.renderer = new three_module["f" /* WebGLRenderer */]({ canvas: this.canvasRef });
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setPixelRatio(window.devicePixelRatio);

    this.uniforms = {
      time: { value: 1.0 }
    };

    var geometry = new three_module["c" /* PlaneBufferGeometry */](2, 2);
    var material = new three_module["e" /* ShaderMaterial */]({
      uniforms: this.uniforms,
      vertexShader: background.vertex,
      fragmentShader: background.fragment
    });

    this.scene.add(new three_module["a" /* Mesh */](geometry, material));
    this.animate();

    window.addEventListener('resize', this.resizeHandler = this.onWindowResize.bind(this), false);
  };

  _default.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  };

  _default.prototype.onWindowResize = function onWindowResize() {
    this.renderer.setSize(window.innerWidth, window.innerHeight);
  };

  _default.prototype.animate = function animate(timestamp) {
    requestAnimationFrame(this.animate.bind(this));

    this.uniforms.time.value = timestamp / 1000;

    this.renderer.render(this.scene, this.camera);
  };

  _default.prototype.render = function render() {
    var _this2 = this;

    return react_default.a.createElement(Canvas, { innerRef: function innerRef(ref) {
        return _this2.canvasRef = ref;
      } });
  };

  return _default;
}(react_default.a.PureComponent);


// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__("O27J");
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// CONCATENATED MODULE: ./src/index.js




Object(react_dom["render"])(react_default.a.createElement(App__default, null), document.querySelector('#app'));

/***/ })

},[0]);


// WEBPACK FOOTER //
// app.665cdebb.js